import calls from '@/backend/api-calls'

const state = () => ({
  request: null,
  loading: false,
  firstLoad: true
})

// getters
const getters = {
}

// actions
const actions = {
  getSampleRequest: ({commit}, sampleRequestId) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.sampleRequest.get(sampleRequestId)
        .then(resp => {
          commit("setSampleRequest", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  updateSampleRequest: ({commit}, { sampleRequestId, data }) => {
    return new Promise((resolve, reject) => {
      calls.sampleRequest.put(sampleRequestId, data).then(
        resp => {
          commit("setSampleRequest", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addSampleRequest: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.sampleRequests.post(data).then(
        resp => {
          commit("insertSampleRequest", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addAttachment: ({commit}, {sampleRequestId, data}) => {
    return new Promise((resolve, reject) => {
      calls.sampleRequest.addAttachment(sampleRequestId, data).then(
        resp => {
          commit("setSampleRequest", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setSampleRequest(state, data) {
    state.request = data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}